import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import ICurrentUser from 'api/interfaces/users/ICurrentUser';
import {
  CONTACTS,
  FEEDBACK,
  LOG,
  OFFERS,
  PRODUCTS,
  PRODUCT_CONFIGURATIONS,
  PROJECTS,
  ROLES,
  USERS,
} from 'services/types/viewTypes';
import {
  MANAGE_OFFER_CHOICES,
  WRITE_OFFERS,
} from 'services/enums/users/permissions';
import hasPermissionType from 'services/users/hasPermissionType';
import SidebarLanguage from './SidebarLanguage';
import SidebarLink from './SidebarLink';
import SidebarLogout from './SidebarLogout';
import TopImage from '../../assets/LoginBackground.png';
import translations from '../../services/translations/translations';
import '../../style/layout/Sidebar.css';

const Sidebar = ({
  isOpen,
  closeFunction,
  currentUser,
}: {
  isOpen: boolean;
  closeFunction: (open: boolean) => void;
  currentUser: ICurrentUser;
}): JSX.Element | null => {
  const [animate, setAnimate] = useState(false);
  const { t } = useTranslation(translations.common);
  useEffect(() => setAnimate(true), []);

  return (
    <>
      <div
        className={
          animate === false ? 'sidebar-content' : 'sidebar-content enter'
        }
      >
        <img src={TopImage} alt="" className="sidebar-image" />
        {currentUser.views.includes(PROJECTS) ? (
          <SidebarLink
            label={t('Projects')}
            link="/projects"
            sidebarClose={closeFunction}
          />
        ) : null}

        {currentUser.views.includes(OFFERS) ? (
          <SidebarLink
            label={t('Offers')}
            link="/offers"
            sidebarClose={closeFunction}
          />
        ) : null}
        {/* The basic information of the new offers of a department, for its writers */}
        {hasPermissionType(currentUser as any, WRITE_OFFERS) ? (
          <SidebarLink
            label={t('Offer defaults')}
            link="/offers/defaults"
            sidebarClose={closeFunction}
          />
        ) : null}
        {/* The choices of the dropdown lists of the offers, for their admins */}
        {hasPermissionType(currentUser as any, MANAGE_OFFER_CHOICES) ? (
          <SidebarLink
            label={t('Offer choices')}
            link="/offers/choices"
            sidebarClose={closeFunction}
          />
        ) : null}

        {currentUser.views.includes(PRODUCTS) ||
        currentUser.views.includes(PRODUCT_CONFIGURATIONS) ? (
          <SidebarLink
            label={t('Products')}
            link="/products"
            sidebarClose={closeFunction}
          />
        ) : null}

        {currentUser.views.includes(CONTACTS) ? (
          <SidebarLink
            label={t('Contacts')}
            link="/contacts"
            sidebarClose={closeFunction}
          />
        ) : null}

        <SidebarLink
          label={t('Work Safety')}
          link="/NotYetImplemented"
          sidebarClose={closeFunction}
        />
        {/* The offer dashboard, for the users of the offers */}
        <SidebarLink
          label={t('Reports')}
          link={
            currentUser.views.includes(OFFERS)
              ? '/reports/offers'
              : '/NotYetImplemented'
          }
          sidebarClose={closeFunction}
        />
        {/* The contracts and sites of the offers on a timeline */}
        {currentUser.views.includes(OFFERS) ? (
          <SidebarLink
            label={t('Offer timeline')}
            link="/reports/timeline"
            sidebarClose={closeFunction}
          />
        ) : null}
        {/* The log of all offers, only with the right to read the log */}
        {currentUser.views.includes(LOG) ? (
          <SidebarLink
            label={t('Log')}
            link="/reports/log"
            sidebarClose={closeFunction}
          />
        ) : null}
        {/* The feedback of the users, for those who read or handle it */}
        {currentUser.views.includes(FEEDBACK) ? (
          <SidebarLink
            label={t('feedback.List title')}
            link="/reports/feedback"
            sidebarClose={closeFunction}
          />
        ) : null}
        {currentUser.views.includes(USERS) ||
        currentUser.views.includes(ROLES) ? (
          <SidebarLink
            label={t('User Management')}
            link="/users"
            sidebarClose={closeFunction}
          />
        ) : null}
        <SidebarLanguage />
        <SidebarLogout />
      </div>
      <div
        className={
          animate === false ? 'sidebar-outside' : 'sidebar-outside sidebar-dark'
        }
        onClick={() => closeFunction(false)}
        aria-hidden="true"
      />
    </>
  );
};

const mapStateToProps = (state: any) => ({
  currentUser: state.users.current,
});

export default connect(mapStateToProps)(Sidebar);
